import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import _ from "lodash";
import { Chart, ArcElement } from "chart.js";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";
import { faFileDownload, faPrint, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import WindowedSelect from "react-windowed-select";
import { Card, Row, Col, Input, Button, Table, DatePicker, Space, Collapse, Modal, Checkbox } from "antd";
import ReactToPrint from "react-to-print";

Chart.register(ArcElement);

function TimeReports(props) {
  //filter options
  const [users, setUsers] = useState([]);
  const [clientCategories, setClientCategories] = useState([]);
  const [clients, setClients] = useState([]);
  const [itemCategories, setItemCategories] = useState([]);
  const [items, setItems] = useState([]);
  const [billingStatusCategories, setBillingStatusCategories] = useState([]);
  const [billingStatuses, setBillingStatuses] = useState([]);
  const [taskStatuses, setTaskStatuses] = useState([]);
  const [groupings, setGroupings] = useState([{ label: "User", value: "time_by" }]);
  const [extraFiltersShown, setExtraFiltersShown] = useState(false);

  //filter
  const [timeReportFilters, setTimeReportFilters] = useState({
    daterange_start: dayjs().subtract(1, "month").startOf("month"),
    daterange_end: dayjs().subtract(1, "month").endOf("month"),
    users: [],
    client_categories: [],
    clients: [],
    item_categories: [],
    items: [],
    billing_status_categories: [],
    billing_statuses: [],
    task_statuses: [],
    partners: [],
    managers: [],
  });

  const [timeEntries, setTimeEntries] = useState([]);
  const [flatTimeEntries, setFlatTimeEntries] = useState([]);
  const [filteredTimeEntries, setFilteredTimeEntries] = useState([]);
  const [timeEntriesSearchTerm, setTimeEntriesSearchTerm] = useState("");

  const printableRef = useRef();

  const [timeReportColumns, setTimeReportColumns] = useState([
    {
      title: "User",
      dataIndex: "created_by",
      key: "created_by",
      force_show: true,
      render: (value, row) => (row.special ? <b>{value}</b> : value),
      sorter: (a, b) => (a.created_by.toUpperCase() > b.created_by.toUpperCase() ? 1 : -1),
    },
    {
      title: "Client Name",
      dataIndex: "client_name",
      key: "client_name",
      render: (value, row) => (row?.client_tag ? <Link to={"/client-details/" + row.client_tag}>{value}</Link> : value),
      sorter: (a, b) => (a.client_name?.toUpperCase() > b.client_name?.toUpperCase() ? 1 : -1),
    },
    {
      title: "Job",
      dataIndex: "job_name",
      key: "job_name",
      sorter: (a, b) => (a.job_name.toUpperCase() > b.job_name.toUpperCase() ? 1 : -1),
    },
    {
      title: "Task",
      dataIndex: "task_description",
      key: "task_description",
      sorter: (a, b) => (a.task_description.toUpperCase() > b.task_description.toUpperCase() ? 1 : -1),
    },
    {
      title: "Item",
      dataIndex: "item_name",
      key: "item_name",
      sorter: (a, b) => (a.item_name.toUpperCase() > b.item_name.toUpperCase() ? 1 : -1),
    },
    {
      title: "Date of Work",
      dataIndex: "time_at",
      key: "time_at",
      render: (value) => props.MakeDateTimeReadable(value),
      sorter: (a, b) => (a.time_at > b.time_at ? 1 : -1),
    },
    {
      title: "Hours",
      dataIndex: "hours",
      key: "hours",
      align: "right",
      render: (value, row) => props.FormatNumberTwoDecimals(value),
      sorter: (a, b) => (a.hours > b.hours ? 1 : -1),
    },

    {
      title: "Extended Rate",
      dataIndex: "bill_rate",
      key: "bill_rate",
      align: "right",
      render: (value, row) => (row.special ? props.FormatNumberToCurrency(row.extended_rate_total) : props.FormatNumberToCurrency(row.hours * row.bill_rate)),
      sorter: (a, b) => (a.hours * a.bill_rate > b.hours * b.bill_rate ? 1 : -1),
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
      render: (value, row) => (row.special ? null : <Input.TextArea value={value} readOnly />),
      sorter: (a, b) => (a.comments.toUpperCase() > b.comments.toUpperCase() ? 1 : -1),
    },
    {
      title: "Billing Status",
      dataIndex: "billing_status_name",
      key: "billing_status_name",
      sorter: (a, b) => (a.billing_status_name.toUpperCase() > b.billing_status_name.toUpperCase() ? 1 : -1),
    },
    {
      title: "Task Status",
      dataIndex: "task_status_name",
      key: "task_status_name",
      sorter: (a, b) => (a.billing_status_name.toUpperCase() > b.billing_status_name.toUpperCase() ? 1 : -1),
    },
    {
      title: "",
      dataIndex: "count",
      force_show: true,
      key: "count",
      align: "right",
      //sorter: (a, b) => (a.billing_status_name.toUpperCase() > b.billing_status_name.toUpperCase() ? 1 : -1),
    },
  ]);

  const [columnToggleModalOpen, setColumnToggleModalOpen] = useState(false);

  const GetUsers = async () => {
    let response = await props.AxiosRequest("/api/users/get");
    setUsers(
      response.data.users.map((m) => {
        return { ...m, value: m.id, label: m.name };
      }),
    );
  };
  const GetClientCategories = async () => {
    let response = await props.AxiosRequest("/api/client-categories/get");
    setClientCategories(
      response.data.client_categories.map((m) => {
        return { ...m, value: m.id, label: m.name };
      }),
    );
  };
  const GetClients = async () => {
    let response = await props.AxiosRequest("/api/clients/get/all");
    setClients(
      response.data.clients.map((m) => {
        return { ...m, value: m.id, label: m.name };
      }),
    );
  };
  const GetItemCategories = async () => {
    let response = await props.AxiosRequest("/api/item-categories/get");
    setItemCategories(
      response.data.item_categories.map((m) => {
        return { ...m, value: m.id, label: m.name };
      }),
    );
  };
  const GetItems = async () => {
    let response = await props.AxiosRequest("/api/items/get");
    setItems(
      response.data.items.map((m) => {
        return { ...m, value: m.id, label: m.name };
      }),
    );
  };
  const GetBillingStatusCategories = async () => {
    let response = await props.AxiosRequest("/api/billing-status-categories/get");
    setBillingStatusCategories(
      response.data.billing_status_categories.map((m) => {
        return { ...m, value: m.id, label: m.name };
      }),
    );
  };
  const GetBillingStatuses = async () => {
    let response = await props.AxiosRequest("/api/billing-statuses/get");
    setBillingStatuses(
      response.data.billing_statuses.map((m) => {
        return { ...m, value: m.id, label: m.name };
      }),
    );
  };
  const GetTaskStatuses = async () => {
    let response = await props.AxiosRequest("/api/task-statuses/get");
    setTaskStatuses(
      response.data.task_statuses.map((m) => {
        return { ...m, value: m.id, label: m.name };
      }),
    );
  };
  const GetTimeEntries = async () => {
    if (!timeReportFilters.daterange_start || !timeReportFilters.daterange_end) return props.MakeNotification("warning", "Please select a daterange.");
    let response = await props.AxiosRequest("/api/time-entries/get/reporting", timeReportFilters);
    let grouped_data = await GroupTimeEntryData(response.data.data);
    setFlatTimeEntries(response.data.data);
    setTimeEntries(grouped_data);
  };
  const GroupTimeEntryData = async (data) => {
    if (groupings.length === 0) return data;
    let grouped_data = _.groupBy(data, (result) => groupings.reduce((a, b) => a + result[b.value] + ", ", "").slice(0, -2));
    let grouped_data_array = _.keys(grouped_data).map((m) => {
      return {
        created_by: m,
        special: true,
        key: "group-" + m,
        count: "Total Time Entries: " + grouped_data[m].length,
        children: grouped_data[m],
        hours: props.FormatNumberTwoDecimals(grouped_data[m].reduce((a, b) => a + b.hours, 0)),
        extended_rate_total: props.FormatNumberTwoDecimals(grouped_data[m].reduce((a, b) => a + b.hours * b.bill_rate, 0)),
      };
    });
    return grouped_data_array;
  };
  const FilterTimeEntries = async () => {
    if (timeEntriesSearchTerm?.length === 0) return setFilteredTimeEntries(timeEntries);
    let filtered_list = timeEntries.filter((f) =>
      _.toLower(f.client_name).indexOf(_.toLower(timeEntriesSearchTerm)) > -1 ||
      _.toLower(f.job_name).indexOf(_.toLower(timeEntriesSearchTerm)) > -1 ||
      _.toLower(f.description).indexOf(_.toLower(timeEntriesSearchTerm)) > -1 ||
      _.toLower(f.created_by).indexOf(_.toLower(timeEntriesSearchTerm)) > -1 ||
      _.toLower(f.item_name).indexOf(_.toLower(timeEntriesSearchTerm)) > -1 ||
      _.toLower(f.time_at).indexOf(_.toLower(timeEntriesSearchTerm)) > -1 ||
      _.toLower(f.hours).indexOf(_.toLower(timeEntriesSearchTerm)) > -1 ||
      _.toLower(f.comments).indexOf(_.toLower(timeEntriesSearchTerm)) > -1 ||
      _.toLower(f.billing_status_name).indexOf(_.toLower(timeEntriesSearchTerm)) > -1
        ? true
        : false,
    );
    setFilteredTimeEntries(filtered_list);
  };

  useEffect(() => {
    GetUsers();
    GetClientCategories();
    GetClients();
    GetItemCategories();
    GetItems();
    GetBillingStatusCategories();
    GetTaskStatuses();
    GetBillingStatuses();
    GetTimeEntries();
  }, []);

  useEffect(() => {
    let local_preference = localStorage.getItem("time-report-columns");
    if (local_preference) {
      local_preference = JSON.parse(local_preference);
      setTimeReportColumns(
        timeReportColumns.map((col) => {
          return { ...col, hidden: local_preference.find((f) => f.key === col.key).hidden };
        }),
      );
    }
  }, []);

  useEffect(() => {
    FilterTimeEntries();
  }, [timeEntries, timeEntriesSearchTerm]);

  return (
    <div className="container-fluid">
      <div className="header">
        <h1 className="header-title">Time Reports</h1>
      </div>

      <Card
        title={
          <Row gutter={[16, 16]}>
            <Col span={12}>Time Report Filters</Col>
            <Col span={12} className="text-right">
              {/* <FontAwesomeIcon icon={faQuestionCircle} size="small" /> */}
            </Col>
          </Row>
        }
      >
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <label className="m-1">Date Range</label>
            <DatePicker.RangePicker
              className="w-100"
              allowClear={false}
              format="MM/DD/YYYY"
              presets={props.default_rangepicker_presets}
              value={[timeReportFilters.daterange_start, timeReportFilters.daterange_end]}
              onCalendarChange={(dates) => {
                if (!dates) return setTimeReportFilters({ ...timeReportFilters, daterange_start: null, daterange_end: null });
                setTimeReportFilters({ ...timeReportFilters, daterange_start: dates[0], daterange_end: dates[1] });
              }}
            />
          </Col>
          <Col span={6}>
            <label className="m-1">Users</label>
            <Select
              isMulti
              options={props.MakeUserOptions(users)}
              value={timeReportFilters.users}
              onChange={(e) => {
                setTimeReportFilters({ ...timeReportFilters, users: e });
              }}
              placeholder="All Users"
            />
          </Col>
          <Col span={6}>
            <label className="m-1">Clients</label>
            <WindowedSelect
              isMulti
              options={props.MakeClientOptions(clients)}
              value={timeReportFilters.clients}
              onChange={(e) => {
                setTimeReportFilters({ ...timeReportFilters, clients: e });
              }}
              placeholder="All Clients"
            />
          </Col>
          <Col span={6}>
            <label className="m-1">Items</label>
            <Select
              isMulti
              options={items}
              value={timeReportFilters.items}
              onChange={(e) => {
                setTimeReportFilters({ ...timeReportFilters, items: e });
              }}
              placeholder="All Items"
            />
          </Col>

          <Col span={24}>
            <Collapse
              style={{ paddingRight: "0px", paddingLeft: "0px" }}
              expandIcon={() => <></>}
              ghost
              items={[
                {
                  key: "1",
                  label: (
                    <Col span={24} className="text-center">
                      <Button
                        size="small"
                        onClick={() => {
                          setExtraFiltersShown(!extraFiltersShown);
                        }}
                      >
                        Show {extraFiltersShown ? "Less" : "More"} Filters
                      </Button>
                    </Col>
                  ),
                  children: (
                    <Row gutter={[16, 16]}>
                      <Col span={6}>
                        <label className="m-1">Client Categories</label>
                        <Select
                          isMulti
                          options={clientCategories}
                          value={timeReportFilters.client_categories}
                          onChange={(e) => {
                            setTimeReportFilters({ ...timeReportFilters, client_categories: e });
                          }}
                          placeholder="All Client Categories"
                        />
                      </Col>
                      <Col span={6}>
                        <label className="m-1">Item Categories</label>
                        <Select
                          isMulti
                          options={itemCategories}
                          value={timeReportFilters.item_categories}
                          onChange={(e) => {
                            setTimeReportFilters({ ...timeReportFilters, item_categories: e });
                          }}
                          placeholder="All Item Categories"
                        />
                      </Col>
                      <Col span={6}>
                        <label className="m-1">Billing Status Category</label>
                        <Select
                          isMulti
                          options={billingStatusCategories}
                          value={timeReportFilters.billing_status_categories}
                          onChange={(e) => {
                            setTimeReportFilters({ ...timeReportFilters, billing_status_categories: e });
                          }}
                          placeholder="All Billing Status Categories"
                        />
                      </Col>
                      <Col span={6}>
                        <label className="m-1">Billing Status</label>
                        <Select
                          isMulti
                          options={billingStatuses}
                          value={timeReportFilters.billing_statuses}
                          onChange={(e) => {
                            setTimeReportFilters({ ...timeReportFilters, billing_statuses: e });
                          }}
                          placeholder="All Billing Statuses"
                        />
                      </Col>
                      <Col span={6}>
                        <label className="m-1">Task Status</label>
                        <Select
                          isMulti
                          options={taskStatuses}
                          value={timeReportFilters.task_statuses}
                          onChange={(e) => {
                            setTimeReportFilters({ ...timeReportFilters, task_statuses: e });
                          }}
                          placeholder="All Task Statuses"
                        />
                      </Col>
                    </Row>
                  ),
                },
              ]}
            ></Collapse>
          </Col>

          <Col span={24}>
            <hr />
          </Col>
          <Col span={8}>
            <label className="m-1">Groupings</label>
            <Select
              isMulti
              options={[
                { label: "User", value: "time_by" },
                { label: "Client", value: "client_name" },
                { label: "Job", value: "job_name" },
                { label: "Item Category", value: "item_category_name" },
                { label: "Item", value: "item_name" },
                { label: "Billing Status Category", value: "billing_status_category_name" },
                { label: "Billing Status", value: "billing_status_name" },
              ]}
              placeholder="Grouped By"
              value={groupings}
              onChange={(e) => {
                setGroupings(e);
              }}
            />
          </Col>
          <Col span={16} className="text-right">
            <label className="m-1 w-100">&nbsp;</label>
            <Button type="primary" onClick={GetTimeEntries} style={{ display: "inline-block", alignSelf: "flex-end" }}>
              Submit
            </Button>
          </Col>
        </Row>
      </Card>
      <br />
      <Card
        className="reports-printable"
        title={
          <Row gutter={[16, 16]}>
            <Col span={12}>Time Report Data</Col>
          </Row>
        }
        ref={printableRef}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Table
              columns={timeReportColumns}
              dataSource={filteredTimeEntries}
              indentSize={0}
              pagination={false}
              summary={(pageData) => {
                let total_hours = 0;
                let total_extended_rate = 0;
                let total_time_entries = 0;
                pageData.forEach(({ hours, extended_rate_total, bill_rate, special, children }) => {
                  total_hours += parseFloat(hours);
                  if (special) total_extended_rate += parseFloat(extended_rate_total);
                  total_time_entries += children?.length;
                });
                return (
                  <>
                    <Table.Summary.Row>
                      {timeReportColumns
                        .filter((f) => !f.hidden)
                        .map((col, ind) => {
                          if (col.key === "created_by") return <Table.Summary.Cell index={ind}>Summary</Table.Summary.Cell>;
                          if (col.key === "hours")
                            return (
                              <Table.Summary.Cell index={ind} align="right">
                                {props.FormatNumberTwoDecimals(total_hours)}
                              </Table.Summary.Cell>
                            );
                          if (col.key === "bill_rate")
                            return (
                              <Table.Summary.Cell index={ind} align="right">
                                {props.FormatNumberToCurrency(total_extended_rate)}
                              </Table.Summary.Cell>
                            );
                          if (col.key === "count")
                            return (
                              <Table.Summary.Cell index={ind} align="right">
                                {total_time_entries}
                              </Table.Summary.Cell>
                            );
                          return <Table.Summary.Cell index={ind} />;
                        })}
                    </Table.Summary.Row>
                  </>
                );
              }}
            />
          </Col>
          <Col span={12}>
            <Button size="small" onClick={() => setColumnToggleModalOpen(true)}>
              Customize Columns
            </Button>
          </Col>
          <Col span={12} className="text-right no-print">
            <Space>
              <CSVLink filename="TimeReport.csv" data={flatTimeEntries.map(({ children, key, special, ...keepAttrs }) => keepAttrs)}>
                <Button type="primary" size="small">
                  <FontAwesomeIcon icon={faFileDownload} className="mr-2" /> Download Detailed CSV File
                </Button>
              </CSVLink>
              <CSVLink filename="TimeReport.csv" data={filteredTimeEntries.map(({ children, key, special, ...keepAttrs }) => keepAttrs)}>
                <Button size="small">
                  <FontAwesomeIcon icon={faFileDownload} className="mr-2" /> Download Summary CSV File
                </Button>
              </CSVLink>
              <ReactToPrint
                trigger={() => (
                  <Button size="small">
                    <FontAwesomeIcon icon={faPrint} className="mr-2" /> Print Report
                  </Button>
                )}
                content={() => printableRef.current}
              />
            </Space>
          </Col>
        </Row>
      </Card>
      <Modal title="Show/Hide Columns" open={columnToggleModalOpen} onOk={() => setColumnToggleModalOpen(false)} onCancel={() => setColumnToggleModalOpen(false)} footer={null}>
        <Row gutter={[16, 16]}>
          <Col span={12}></Col>
          <Col span={12}></Col>
          {timeReportColumns.map((col) => {
            if (!col?.force_show) {
              return (
                <>
                  <Col span={12}>{col?.title ? col?.title : "Last Column"}</Col>
                  <Col span={12}>
                    <Checkbox
                      checked={!col?.hidden}
                      onChange={(e) => {
                        let new_prefs = timeReportColumns.map((m) => {
                          if (m.title === col.title) {
                            return { ...m, hidden: !e.target.checked };
                          }
                          return m;
                        });
                        setTimeReportColumns(new_prefs);
                        localStorage.setItem(
                          "time-report-columns",
                          JSON.stringify(
                            new_prefs.map((col) => {
                              return { key: col.key, hidden: col.hidden };
                            }),
                          ),
                        );
                      }}
                    />
                  </Col>
                </>
              );
            }
          })}
        </Row>
      </Modal>
    </div>
  );
}

export default TimeReports;
